import React from "react";

import styles from "./valueWithTitle.scss";
import {Icon, Tooltip} from "antd";
import { CarverticalVinLink, VIN_DETAIL_TITLE } from "../../../../../../components/CarverticalWidget";

const ValueWithTitle = ({ itemData, className }) => {
  const isVinRow =
    itemData.title === VIN_DETAIL_TITLE && itemData.value && itemData.value.length > 0;

  return (
    <div className={`${styles.wrapper} ${className}`}>
      { itemData.title && itemData.title.length > 0 &&
        <span>{itemData.title}
          {itemData.tooltip && (
              <Tooltip title={itemData.tooltip} placement="top">
                <Icon
                    className={styles.infoIcon}
                    type="info-circle-o"
                />
              </Tooltip>
          )}
        </span>
      }
      {itemData.value && itemData.value.length > 0 &&
        <span>{itemData.value}</span>
      }
      {isVinRow && (
        <React.Fragment>
          {/* Zero-height full-width flex item forces the wrap so the VIN
              link goes to its own row instead of the flex algorithm
              crushing the label + value spans char-by-char to make room. */}
          <span className={styles.rowBreak} aria-hidden="true" />
          <CarverticalVinLink vin={itemData.value} />
        </React.Fragment>
      )}
    </div>
  );
};

export default ValueWithTitle;



// WEBPACK FOOTER //
// ./src/containers/AdDetailsPage/AdDetailsPageMobile/DetailsSection/GroupData/ValueWithTitle/index.tsx